import http from '@/utils/http'
export function loginbyUser(
  syncTimeStart,
  syncTimeEnd,
  cardNo,
  vehicleNo,
  page,
  pageSize
) {
  const data = {
    syncTimeStart,
    syncTimeEnd,
    cardNo,
    vehicleNo,
    page,
    pageSize
  }
  return http({
    url: '/bi-api/abnormal/querySingle',
    method: 'post',
    data
  })
}
export function getAllCity() {
  //这里需要一个mock数据
  return http({
    url: '/bi-api/auth?t='+new Date()*1,
    method: 'get'
  })
}
export function getProvinceData(areano, syncTimeStart, syncTimeEnd) {
  const data = {
    areano,
    syncTimeStart,
    syncTimeEnd
  }
  return http({
    url: '/bi-api/abnormal/queryArea',
    method: 'get',
    params: data
  })
}

export function getAreaData(areano, syncTimeStart, syncTimeEnd) {
  const data = {
    areano,
    syncTimeStart,
    syncTimeEnd
  }
  return http({
    url: '/bi-api/abnormal/queryArea',
    method: 'get',
    params: data
  })
}

export function getList(data) {
  return http({
    url: '/bi-api/abnormal/queryList',
    method: 'post',
    data
  })
}
// export function logout() {
//   return http({
//     url: '/login/logout',
//     method: 'post'
//   })
// }

// export function getUserInfo(username) {
//   return http({
//     url: '/user/info',
//     method: 'get',
//     params: { username }
//   })
// }
